import styled from "styled-components";
interface Props {
  isSelected: boolean;
}
export const Content = styled.div<Props>`
  width: 280px;
  height: 435px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.secondary10};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  border: ${({ theme, isSelected }) =>
    isSelected ? `2px solid ${theme.colors.primary}` : ""};
  &:hover {
    box-shadow: 0px 16px 15px rgba(0, 0, 0, 0.64);
  }
  img {
    width: 180px;
  }
  h3 {
    margin: 0px;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.secondary100};
  }
  h1 {
    margin: 0px;
    font-size: 2vw;
    color: ${({ theme }) => theme.colors.secondary100};
    font-weight: 600;
  }
  .horinzontal-line {
    width: 60%;
    height: 2px;
    background-color: ${({ theme }) => theme.colors.secondary100};
    border-radius: 8px;
    margin: 10px 0px;
  }
  .attributes {
    width: 100%;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    .attribute {
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${({ theme }) => theme.colors.secondary100};
      svg {
        margin-right: 5px;
        color: ${({ theme }) => theme.colors.primary};
      }
    }
  }
  .btn {
    margin-top: 50px;
  }
`;
